// extracted by mini-css-extract-plugin
export default {"selectedRows":"tableBulkActionView_selectedRows__0o7ql"};